import React, { useState, useContext, useEffect } from "react";
import { IntlContext } from "context";
import exportDataFetcher, { ExportInterface } from "dataProvider/Export";
import importDataFetcher from "dataProvider/Import";

const ImportRouter: React.FC = () => {
    const intl = useContext(IntlContext);
    const [stateImportMessage, setStateImportMessage] = useState<string[]>([]);
    const [processing, setProcessing] = useState<boolean>(false);
    const [progressExport, setProgressExport] = useState<number>(-1);
    const [exportProgress, setExportProgress] = useState<any>();
    const imports = ["importSource", "importFamilleSecteur", "importAnneeSecteur", "importField", "importProduit"];
    const groups = [
        "description-du-produit",
        "valeurs-nutritionnelles",
        "ingredients",
        "etiquetage-nutritionnel-simplifie",
        "allegations",
        "diagram",
        "labels-logos",
        "historique",
        "diagram-marque",
        // "sources-des-informations",
        "statistique-descriptive",
        "offre-alimentaire",
        "offre-alimentaire-marque",
    ];

    useEffect(() => {}, []);
    useEffect(() => {
        setTimeout(() => updateProgress(), 4000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exportProgress]);

    const updateProgress = () => {
        try {
            if (!exportProgress) {
                return;
            }

            if (exportProgress.status === "ERROR") {
                return;
            }

            // Export terminé
            if (exportProgress.status === "COMPLETED") {
                setExportProgress(100);
                return;
            }

            if (exportProgress.status !== "PROCESSING" && exportProgress.status !== "PENDING") {
                return;
            }

            // Export en cours
            if (exportProgress.id) {
                exportDataFetcher
                    .one(exportProgress.id)
                    .then((data: ExportInterface) => {
                        setExportProgress(data);
                        setProgressExport(Math.floor(((data.written_rows || 0) / (data.total_rows || 1)) * 100));
                    })
                    .catch((err) => {
                        throw err;
                    });
            }
        } catch (e) {
            throw e;
        }
    };

    const executeImport = async (name: string) => {
        try {
            // @ts-ignore
            const result = await importDataFetcher[name]();
            let data = result.data.data || result.data;

            if (!(data instanceof Object)) {
                if (data.indexOf("{") !== -1) {
                    data = JSON.parse(data.substr(data.indexOf("{"))).data;
                }
            }

            setStateImportMessage((state) => [
                ...state,
                intl.formatMessage("import.label.import_started", { name: name.substring(6) }),
            ]);
            setStateImportMessage((state) => [
                ...state,
                intl.formatMessage("import.label.import_result", { value: data.state }),
            ]);
        } catch (err) {
            throw err;
        }
    };

    const runImport = async () => {
        setProcessing(true);
        const exp = imports.map((currentImport: string) => executeImport(currentImport));
        // On lance toutes les promesses
        await Promise.all(exp);
        setStateImportMessage((state) => [...state, intl.formatMessage("import.label.import_finished")]);

        return runExport();
    };

    const runExport = () => {
        setProgressExport(0);
        setStateImportMessage((state) => [...state, intl.formatMessage("import.label.export_started")]);
        importDataFetcher
            .export({
                filter_secteur: [],
                filter_famille: [],
                groups: groups,
            })
            .then((data: any) => {
                setExportProgress(data);
            })
            .catch((err) => {
                throw err;
            });
        return intl.formatMessage("import.label.action.import_result");
    };

    return (
        <React.Fragment>
            <header className="header-product"></header>
            <div className="block-searchbar">
                <div className="container"></div>
            </div>

            <div className="container">
                <button
                    type="button"
                    className="cta cta--primary margin-auto"
                    title={intl.formatMessage("import.label.action.import_result")}
                    disabled={processing}
                    onClick={runImport}
                >
                    {intl.formatMessage("import.label.action.import_result")}
                </button>

                <ul>
                    {stateImportMessage.map((message: string, id: number) => (
                        <li key={id}>{message}</li>
                    ))}

                    {progressExport > -1 && (
                        <li>{intl.formatMessage("import.label.export_state", { value: progressExport })}</li>
                    )}
                    {progressExport === 100 && <li>{intl.formatMessage("import.label.export_ended")}</li>}
                    {progressExport === 100 && <li>{intl.formatMessage("import.label.import_finished")}</li>}
                </ul>
            </div>
        </React.Fragment>
    );
};

export default ImportRouter;
